import { getPolygonArea, randomItem, Vector3toV3 } from "@project-rouge/rg-three";
import { getSubdivisionRatio } from "./index230.js";
import { isValidSubdivision } from "./index231.js";
import { SplitPolyByBBox } from "./index232.js";
import { defaultAggProps } from "./index233.js";
const splitLikelihoodHigher = 0.3;
const splitLikelihoodLower = 0.01;
var SplitDirection = /* @__PURE__ */ ((SplitDirection2) => {
  SplitDirection2[SplitDirection2["transverse"] = 0] = "transverse";
  SplitDirection2[SplitDirection2["longitudinal"] = 1] = "longitudinal";
  return SplitDirection2;
})(SplitDirection || {});
function recursiveSubdivision({ poly, maxCount = defaultAggProps.maxPlotCount, minWidth = defaultAggProps.minWidth, maxLength = defaultAggProps.maxLength, minArea = defaultAggProps.minArea, allowLongitudinalSplit = defaultAggProps.allowLongitudinalSplit, rng }) {
  const splitRatioOptions = [0.5, 0.333, 0.667];
  let splitDirectionOptions;
  if (allowLongitudinalSplit)
    splitDirectionOptions = [
      0,
      1
      /* longitudinal */
    ];
  else
    splitDirectionOptions = [
      0
      /* transverse */
    ];
  const allValidOptions = splitRatioOptions.flatMap((o) => splitDirectionOptions.map((d) => getSubdivisionRatio(o, d)));
  let validOptions = allValidOptions.slice();
  const data = { polygon: poly.slice(), children: [] };
  const root = data;
  const queue = [];
  queue.push(data);
  let count = 1;
  const splitLikelihood = rng && rng() > 0.5 ? splitLikelihoodHigher : splitLikelihoodLower;
  while (queue.length > 0) {
    if (validOptions.length === 0)
      break;
    if (count + 1 > maxCount)
      break;
    let wasPolygonSplit = false;
    queue.sort((a, b) => getPolygonArea(a.polygon.map((v) => v.slice())) - getPolygonArea(b.polygon.map((v) => v.slice())));
    const biggestPoly = queue[queue.length - 1];
    while (validOptions.length > 0) {
      const splitOption = randomItem({ list: validOptions, rng });
      validOptions.splice(validOptions.findIndex((v) => v === splitOption), 1);
      const isValid = isValidSubdivision({
        polygon: biggestPoly.polygon,
        splitOption,
        maxLength,
        minWidth,
        minArea,
        maxCount,
        rng,
        count,
        splitLikelihood
      });
      if (isValid) {
        queue.pop();
        const temp = SplitPolyByBBox(biggestPoly.polygon, splitOption.ratio, splitOption.direction).map((p) => p.map(Vector3toV3));
        const newData = [];
        for (const p of temp)
          newData.push({ polygon: p, children: [] });
        biggestPoly.ratio = splitOption.ratio;
        biggestPoly.splitDirection = splitOption.direction;
        biggestPoly.children.push(...newData);
        queue.push(...newData);
        count++;
        wasPolygonSplit = true;
        break;
      }
    }
    if (wasPolygonSplit === false)
      queue.pop();
    validOptions = allValidOptions.slice();
  }
  const polygons = getLeafPolygons(root);
  return { polygons, root };
}
function getLeafPolygons(divisionData) {
  const polygons = [];
  if (divisionData.children.length === 0)
    polygons.push(divisionData.polygon);
  else
    for (const d of divisionData.children)
      polygons.push(...getLeafPolygons(d));
  return polygons;
}
export {
  SplitDirection,
  recursiveSubdivision
};
//# sourceMappingURL=index185.js.map
